import {
  ADD_DREAM,
  ADD_DREAM_FAILURE,
  ADD_DREAM_SUCCESS,
  EDIT_DREAM,
  EDIT_DREAM_FAILURE,
  EDIT_DREAM_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
};
export default function DreamManagementReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_DREAM:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_DREAM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case ADD_DREAM_FAILURE:
      console.log(action.payload, 'mmmmmmm');
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    case EDIT_DREAM:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_DREAM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case EDIT_DREAM_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    default:
      return {
        ...state,
      };
  }
}
